export default __webpack_public_path__ + "static/media/delete-menu.d7ec9ac0.svg";